import { Component } from '@angular/core';

import { MigrationSource } from '../migration-reusable-components/migration-source.enum';
import { MigrationConstants } from '../migration-reusable-components/migration-constants';

@Component({
	selector: 'app-migration-third-party-apps',
	templateUrl: './migration-third-party-apps.component.html',
	styleUrls: ['./migration-third-party-apps.component.scss']
})
export class MigrationThirdPartyAppsComponent {
	readonly PREPARE_FOR_MIGRATION_LINK = MigrationConstants.PREPARE_FOR_MIGRATION_LINK;
	readonly migrationSource = MigrationSource.TAXCOMPETITOR;
}
